
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { PageBuilderItemProps } from ".";
import { history } from "store/page-builder";

interface ApiPageBuilderHistoryInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
    pageId: number;
}

type ApiPageBuilderHistoryOutputProps = OutputBaseProps<{ list: PageBuilderItemProps[]; active?: PageBuilderItemProps; pagination?: PaginationProps; }>

export const apiPageBuilderHistory = async (data: ApiPageBuilderHistoryInputProps) => {
    const res = (await axios.get<ApiPageBuilderHistoryOutputProps>("/api/page-builder/history", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(history({ data: res.data.list, refresh: data.page === 1, pagination: res.data.pagination }));
    }
    return res;
}; 